export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20shopping%20scene%20with%20glowing%20neon%20signs%20and%20stylish%20product%20display%20windows%2C%20modern%20boutique%20storefront%20at%20twilight%2C%20warm%20golden%20interior%20lights%20spilling%20onto%20wet%20pavement%2C%20urban%20night%20shopping%20atmosphere%2C%20cinematic%20mood&width=1600&height=700&seq=cta-bg-v2-001&orientation=landscape"
          alt="LitBuy Spreadsheet lifestyle scene"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 to-foreground-950/65"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1440px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5 tracking-tight">
          START TRACKING SMARTER
        </h2>
        <p className="text-sm md:text-base text-background-200/90 max-w-[560px] mx-auto leading-relaxed mb-10">
          LitBuy Spreadsheet connects you with the best deals across all your favorite categories. Visit KASpreadsheet now to explore the full collection and start saving today.
        </p>

        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-background-50 text-foreground-900 font-semibold text-sm hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer group"
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50 group-hover:bg-primary-600 transition-colors">
            <i className="ri-shopping-bag-line text-base"></i>
          </span>
          VISIT KASPREADSHEET.COM
          <i className="ri-arrow-right-up-line text-lg"></i>
        </a>

        <p className="mt-8 text-xs text-background-300/70">
          Trusted by thousands of shoppers &bull; 14+ categories &bull; Free to browse
        </p>
      </div>
    </section>
  );
}